import { TFunction } from 'i18next';
import React, { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { UseMutationResult } from 'react-query';
import { NewUserType } from 'v2-types/user';
import { getContactErrorMessage } from 'views/contacts/services/errors';

const useMutations = (
  history: any,
  methods: UseFormReturn<NewUserType, any>,
  setErrors: React.Dispatch<React.SetStateAction<string[]>>,
  responseDeleteParty: UseMutationResult<any, any, any, any>,
  t: TFunction
) => {
  useEffect(() => {
    if (responseDeleteParty.isSuccess && responseDeleteParty.data) {
      responseDeleteParty.reset();
      history.push('/contacts');
    }

    if (responseDeleteParty.isError) {
      const message = getContactErrorMessage(responseDeleteParty.error, t);
      responseDeleteParty.reset();
      setErrors((prev) => [...prev, message]);
    }
  }, [responseDeleteParty, methods, history, setErrors, t]);
  return null;
};

export default useMutations;
